import { render, staticRenderFns } from "./ProfessionInput.vue?vue&type=template&id=ceea8680&scoped=true"
import script from "./ProfessionInput.vue?vue&type=script&lang=js"
export * from "./ProfessionInput.vue?vue&type=script&lang=js"
import style0 from "./ProfessionInput.vue?vue&type=style&index=0&id=ceea8680&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceea8680",
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect});
